import { useState, useEffect } from "react";
import { toast } from "sonner";
import { UserCog } from "lucide-react";
import api from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { adminMenu } from "@/config/menus";
import { PageHeader } from "@/components/KpiCard";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { LoadingScreen } from "@/components/common";

export default function AdminUsers() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/users").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const toggleLM = async (u) => {
    const enabled = !(u.roles || []).includes("lead_manager");
    setRows((rs) => rs.map((x) => x.user_id === u.user_id ? { ...x, roles: enabled ? [...(x.roles || []), "lead_manager"] : (x.roles || []).filter((r) => r !== "lead_manager") } : x));
    try { await api.put(`/admin/users/${u.user_id}/lead-manager`, { enabled }); toast.success(enabled ? "Lead Manager granted" : "Lead Manager removed"); }
    catch { toast.error("Failed"); load(); }
  };

  return (
    <DashboardShell menu={adminMenu} title="Users">
      <PageHeader title="Platform Users" subtitle="Customers, agencies and administrators. Grant trusted staff the Lead Manager role to handle lead distribution." />
      {!rows ? <LoadingScreen /> : (
        <div className="bg-white border border-navy-200 rounded-xl overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead className="bg-navy-50 text-navy-500 text-xs uppercase"><tr><th className="text-left p-3">Name</th><th className="text-left p-3">Email</th><th className="p-3">Roles</th><th className="p-3">Lead Manager</th><th className="p-3">Joined</th></tr></thead>
            <tbody>
              {rows.map((u) => (
                <tr key={u.user_id} className="border-t border-navy-100" data-testid={`user-${u.user_id}`}>
                  <td className="p-3 font-medium text-navy-900">{u.name}</td>
                  <td className="p-3 text-navy-600">{u.email}</td>
                  <td className="p-3 text-center">
                    <div className="flex gap-1 justify-center flex-wrap">
                      {(u.roles || []).map((r) => <Badge key={r} variant="outline" className={`capitalize ${r === "admin" ? "border-brand text-brand" : r === "lead_manager" ? "border-indigo-400 text-indigo-600" : "border-navy-300 text-navy-600"}`}>{r.replace("_", " ")}</Badge>)}
                    </div>
                  </td>
                  <td className="p-3 text-center">
                    {(u.roles || []).includes("admin")
                      ? <span className="text-xs text-navy-400">Super Admin</span>
                      : <Switch checked={(u.roles || []).includes("lead_manager")} onCheckedChange={() => toggleLM(u)} data-testid={`lm-toggle-${u.user_id}`} />}
                  </td>
                  <td className="p-3 text-center text-navy-500 text-xs">{u.created_at?.slice(0, 10)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DashboardShell>
  );
}
